import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { HERO } from "@/constants/testIds";
import HeroCanvas from "./HeroCanvas";
import { RevealWords, FadeUp } from "./Reveal";

export default function Hero() {
	const ref = useRef(null);
	const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
	const yImg = useTransform(scrollYProgress, [0, 1], ["-2%", "5%"]);

	return (
		<section
			id="top"
			ref={ref}
			data-testid={HERO.section}
			className="relative overflow-hidden border-t border-[var(--border-line)] bg-[var(--obsidian)] text-[var(--bone)] pt-32 pb-16 md:pt-40 md:pb-20"
		>
			<div className="max-container grid grid-cols-12 gap-6 items-start">
				{/* Left: invitation copy */}
				<div className="col-span-12 lg:col-span-7 relative">
					<FadeUp>
						<div className="step-eyebrow mb-6">Natant AI Labs</div>
					</FadeUp>

					<h1 className="h2x text-[12.5vw] sm:text-[11vw] lg:text-[5.6vw] mb-8">
						<span className="block">
							<RevealWords trigger="onLoad" text="Become a" />
						</span>
						<span className="block acc">
							<RevealWords trigger="onLoad" delay={0.12} text="Super" />
						</span>
						<span className="block">
							<RevealWords trigger="onLoad" delay={0.2} text="Company" />
						</span>
					</h1>

					<FadeUp delay={0.45}>
						<p className="text-base md:text-lg leading-relaxed text-[var(--bone-dim)] max-w-[52ch] mb-8">
							Natant is the AI-native operating system that runs a whole company — one system in place of CRM, ERP and commerce silos, designing, running and tuning itself.
						</p>
					</FadeUp>

					<FadeUp delay={0.65}>
						<div className="flex flex-wrap items-center gap-3">
							<a
								href="/apply"
								data-testid={HERO.applyCta}
								className="pill-btn"
								style={{ background: "var(--accent-green)", borderColor: "var(--accent-green)", color: "#fff" }}
							>
								Take the open seat →
							</a>
							<a href="/whitepaper" data-testid={HERO.thesisCta} className="pill-btn pill-btn--ghost">
								Read Whitepaper 01
							</a>
						</div>
					</FadeUp>
				</div>

				{/* Right: the network visual */}
				<div className="col-span-12 lg:col-span-5 lg:pl-6 mt-10 lg:mt-0">
					<FadeUp delay={0.35} y={24}>
						<div className="clip-frame aspect-[4/5]">
							<motion.div style={{ y: yImg }} className="absolute inset-0">
								<HeroCanvas />
							</motion.div>
						</div>
					</FadeUp>
				</div>
			</div>
		</section>
	);
}
